import FreightForm from './FreightForm'

export default FreightForm
